var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"image, card-heading, list-item-three-line, divider, card-heading, list-item-three-line, list-item-three-line, actions"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }